<p-button 
    icon="pi pi-tag" 
    [label]="etiquette() ? etiquette()!.shortDescription! : label()" 
    [severity]="severity()" 
    styleClass="m-0" 
    size="small"/>
